var fitt = require('fitt'),
isFunc = fitt.isFunc,
PROTO = fitt.PROTO,
MAX_ATTEMPTS = 2;


/**
                   * A utility to retry Promises.
                   *
                   * @param {Function} fn       Function to retry
                   * @param {Object} options    Options
                   */
function PromiseRetry(fn, options) {
    var me = this,
    attempts = options && options.attempts || MAX_ATTEMPTS,
    getWaitTime = options && options.getWaitTime;

    if (!isFunc(fn)) {
        throw new Error('Missing `function` argument.');
    }

    if (isFunc(getWaitTime)) {
        me.getWaitTime = getWaitTime;
    }

    me.fn = fn;
    me.retries = 0;
    me.attempts = attempts;
}


function PromiseRetry_try(err) {
    var me = this;

    return new Promise(function PromiseRetryWrapper(resolve, reject) {

        var wrappedPromise = me.fn(err, me.retries);

        if (!(wrappedPromise instanceof Promise)) {
            reject('Function did not return a Promise.');
        }

        wrappedPromise.
        then(function PromiseRetry_onSuccess(response) {
            resolve(response);
        }).
        catch(function PromiseRetry_onError(error) {

            var timeout;

            if (++me.retries < me.attempts) {

                if (me.getWaitTime) {
                    timeout = me.getWaitTime.apply(me, arguments);
                }

                if (timeout) {
                    setTimeout(function () {
                        resolve(me.try(error));
                    }, timeout);
                } else {
                    resolve(me.try(error));
                }

            } else {
                reject(error);
            }

        });

    });
}


PromiseRetry[PROTO] = {
    try: PromiseRetry_try };


module.exports = PromiseRetry;


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-promise-retry/index.js
// module id = 791
// module chunks = 0